import React, {useEffect, useState} from 'react';
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import {makeStyles} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column'
        },
        '& > *': {
            margin: theme.spacing(2),
        },
        '& .MuiTextField-root': {
            width: '100%',
        },
    },
    actions: {
        '& > *': {
            marginRight: theme.spacing(2),
        },
    }
}));

const GroupGeneralInfo = ({
    group,
    onNameChange,
    onClose
}: any) => {
    const classes = useStyles();
    const [name, setName] = useState(group.name || '');
    const [error, setError] = useState<string | null>(null);
    const [submitted, setSubmitted] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const {t} = useTranslation();

    useEffect(() => {
        setName(group.name);
    }, [group]);

    const handleFormChange = (e: any) => {
        e.preventDefault();
        const value = e.target.value;
        setName(value);
        if (!value) setError('FieldIsRequired');
        else if (error) {
            setError(null);
            setSubmitted(false);
        }
    };

    const onSave = (e: any) => {
        e.preventDefault();
        if (submitted) return;
        setSubmitted(true);
        if (error) return;
        if (!name) return setError('FieldIsRequired');
        onNameChange(name)
            .then(() => setEditMode(false))
            .finally(() => setSubmitted(false));
    };

    const onCancel = (e: any) => {
        e.preventDefault();
        if (submitted) return;
        setError(null);
        setName(group.name);
        setEditMode(false);
    };

    return editMode ?
               <Grid container spacing={3}>
                        <Grid item xs={12}>
                                <Typography variant="body1">{t('ProGuest.Groups.Tabs.General.Description')}</Typography>
                                <form className={classes.root} onSubmit={onSave} noValidate autoComplete="off">
                                        <TextField
                        name='name'
                        error={submitted && !!error}
                        value={name}
                        onChange={handleFormChange}
                        label={t('ProGuest.Groups.Name')}
                        helperText={submitted && error ? t(`_Common.Messages.${error}`) : null}
                    />
                </form>
                                <Grid xs={12} item={true} container justify="flex-end" direction="row" className={classes.actions}>
                                        <Button variant="outlined" color="primary" size="medium"
                            onClick={onCancel}>
                        {t('_Common.Labels.Cancel')}
                    </Button>
                                        <Button variant="contained" color="primary" size="medium"
                            onClick={onSave}>
                        {t('_Common.Labels.Save')}
                    </Button>
                </Grid>
            </Grid>
        </Grid>
        :
               <Grid container spacing={3}>
                        <Grid item xs={12}>
                                <Typography variant="body1">{t('ProGuest.Groups.Tabs.General.GroupName')}</Typography>
                                <div className={classes.root}>
                                        <TextField
                        disabled
                        name='name'
                        value={name}
                        label={t('ProGuest.Groups.Name')}
                    />
                                        <Button color="primary" size="small"
                            onClick={() => setEditMode(true)}>
                        {t('_Common.Labels.Edit')}
                    </Button>
                </div>
                                <Grid xs={12} item={true} container justify="flex-end" direction="row" className={classes.actions}>
                                        <Button variant="outlined" color="primary" size="medium"
                            onClick={onClose}>
                        {t('_Common.Labels.Close')}
                    </Button>
                </Grid>
            </Grid>
        </Grid>
}

export default GroupGeneralInfo;
